import React from 'react';
import './SearchResults.css';
import { NoResult } from '../NoResult';
import { TrendingGames } from '../TrendingGames';
import { SearchGamesList } from '../SearchGamesList';
import { RecentGames } from '../RecentGames';

export const SearchResults = ({
    className = '',
    searchResult = [],
    searchQuery = '',
    searchWindowDimensions = {},
}) => {
    const isInitialSearchState = searchQuery.length === 0;
    const isEmptySearchResult = searchQuery.length > 0 && searchResult.length === 0;

    return (
        <div className={`${className} asg-search-results`}>
            {/* No query yet - show recent and trending games */}
            {isInitialSearchState && <div className="asg-search-results__scrollable">
                <RecentGames />
                <TrendingGames />
            </div>}

            {/* No games found for query */}
            {isEmptySearchResult && <NoResult />}

            {/* Result games */}
            {!isInitialSearchState && !isEmptySearchResult && <SearchGamesList
                searchQuery={searchQuery}
                resultGameIds={searchResult}
                searchWindowDimensions={searchWindowDimensions}
            />}
        </div>
    );
};
